module.exports = __webpack_public_path__ + "img/social-icon-twitter.855b819c.svg";